module.exports = __webpack_public_path__ + "img/cylinder_gear.prt.29ca6575.jpg";